/**
 * The i18n key (in `campaigns`) for a field the campaign API refused, and the
 * 1-based grouping it sits in. The server's own message is English (#1617),
 * so the wizard never prints it: it names the field in the reader's language.
 */
export function campaignInputError(field: string | undefined): { key: string; n?: number } {
    const grouping = /^groupings\[(\d+)\](?:\.items\[\d+\])?\.(\w+)$/.exec(field ?? '')
    if (grouping) {
        const n = Number(grouping[1]) + 1
        switch (grouping[2]) {
            case 'name': return { key: 'wizard.errors.grouping_name', n }
            case 'asset_type_codes': return { key: 'wizard.errors.grouping_type', n }
            case 'label': return { key: 'wizard.errors.question_label', n }
            case 'options': return { key: 'wizard.errors.question_options', n }
            default: return { key: 'wizard.errors.grouping', n }
        }
    }
    switch (field) {
        case 'name': return { key: 'wizard.errors.name' }
        case 'scope_asset_uids': return { key: 'wizard.errors.scope' }
        case 'groupings': return { key: 'wizard.errors.no_item' }
        case 'agent_uids': return { key: 'wizard.errors.agents' }
        case 'due_on': return { key: 'wizard.errors.due_on' }
        case 'data_year': return { key: 'wizard.errors.data_year' }
        default: return { key: 'wizard.errors.generic' }
    }
}
